import { get } from 'lodash';

import Model from 'models';

const UpsellMasterProduct = class extends Model {
  get id() {
    return get(this._firstProduct, 'masterId');
  }

  get products() {
    return this._data;
  }

  get _firstProduct() {
    return get(this.products, 0);
  }

  get material() {
    return get(this._firstProduct, 'material');
  }

  get silhouette() {
    return get(this._firstProduct, 'silhouette');
  }

  get gender() {
    return get(this._firstProduct, 'gender');
  }

  get type() {
    return get(this._firstProduct, 'type');
  }
};

export default UpsellMasterProduct;
